import React, { useEffect, useState } from "react";
import HoverCard from "./HoverCard";

const NewReleases = () => {
  const [games, setGames] = useState([]);

  useEffect(() => {
    fetch(`/api/newreleases`)
      .then((res) => res.json())
      .then((data) => {
        const parsedGames = data.slice(0, 8).map((game) => ({
          id: game.id,
          title: game.name,
          releaseDateUnix: game.first_release_date,
          releaseDate: new Date(game.first_release_date * 1000).toLocaleDateString(),
          cover: game.coverUrl || "/StockGameCover.jpg",
          summary: game.storyline || "No synopsis available.",
          rating: game.rating ? game.rating.toFixed(1) : "N/A",
          trailerUrl: game.trailerUrl
            ? game.trailerUrl.replace("watch?v=", "embed/")
            : null,
        }));
        setGames(parsedGames);
      })
      .catch((error) => {
        console.error("Failed to load games:", error);
      });
  }, []);

  return (
    <section className="bg-gradient-to-br from-[#0f172a] to-[#1e293b] text-white py-14 px-6">
      <h2 className="text-4xl font-extrabold text-center text-blue-400 mb-12">
        New Releases
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 justify-items-center max-w-7xl mx-auto">
        {games.map((game, index) => (
          <div key={index} className="relative group w-full max-w-xs">
            {/* Basic Card */}
            <div className="bg-gray-800 p-4 rounded-xl shadow transition duration-300 group-hover:shadow-blue-500/50">
              <img
                src={game.cover}
                alt={game.title}
                className="w-full h-44 object-contain rounded mb-4"
              />
              <h3 className="font-semibold text-lg text-center">{game.title}</h3>
              <p className="text-sm text-gray-400 text-center">
                Released on {game.releaseDate}
              </p>
              <p className="text-sm text-yellow-400 text-center mt-1">
                Rating: {game.rating}
              </p>
            </div>

            {/* Hover Card */}
            <HoverCard gameId={game.id} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewReleases;
